import React from 'react';

const StatusIndicators = () => (
  <div className="flex items-center gap-1 text-[10px] font-semibold text-slate-500">
    <span>9:41</span>
    <div className="ml-auto flex items-center gap-1">
      <span className="h-2 w-3 rounded-sm bg-slate-500" />
      <span className="h-2 w-2 rounded-sm bg-slate-500" />
      <span className="h-2 w-2 rounded-full border border-slate-500" />
    </div>
  </div>
);

const ActionDots = () => (
  <div className="flex items-center gap-2">
    <span className="h-2.5 w-2.5 rounded-full bg-slate-300" />
    <span className="h-2.5 w-2.5 rounded-full bg-slate-300" />
    <span className="h-2.5 w-2.5 rounded-full bg-slate-300" />
  </div>
);

const MobilePreviewFrame = ({ children, label = 'Email Preview' }) => {
  return (
    <div className="relative mx-auto w-full max-w-[460px] px-4 py-6">
      <div className="relative mx-auto flex w-[360px] max-w-full flex-col rounded-[48px] border-[10px] border-slate-900 bg-slate-900 text-slate-50 shadow-[0_30px_80px_rgba(15,23,42,0.45)]">
        <div className="mx-auto mt-1.5 h-6 w-28 rounded-full bg-slate-800" />
        <div className="mt-3 flex min-h-[640px] flex-col rounded-[34px] bg-slate-100 p-4">
          <StatusIndicators />
          <div className="mt-3 flex items-center justify-between rounded-2xl bg-white px-4 py-2 text-[11px] text-slate-500 shadow-inner">
            <div>
              <p className="text-[12px] font-semibold text-slate-800">{label}</p>
              <p>Inbox • 1</p>
            </div>
            <ActionDots />
          </div>
          <div className="mt-3 flex-1 overflow-hidden rounded-[22px] bg-white shadow-[inset_0_0_0_1px_rgba(15,23,42,0.08)]">
            <div className="h-full w-full overflow-hidden rounded-[22px]">
              {children}
            </div>
          </div>
          <div className="mx-auto mt-4 h-1.5 w-16 rounded-full bg-slate-400" />
        </div>
      </div>
    </div>
  );
};

export default MobilePreviewFrame;
